import {Injectable} from "@angular/core";
import {
  ConversationClient,
  ConversationDeleteRequestModel,
  ConversationDeleteResponseModel,
  ConversationMessageSubmitRequestModel,
  DTOImage,
  MessageSubmitResponseModel, StartConversationMessageSubmitRequestModel,
  UserConversationsRequestModel,
  UserConversationsResponseModel,

  DTOConversation,
  ConversationAdditionalInformations
} from "../api/WickedApiClient";
import { Moment } from "moment";


@Injectable({
  providedIn: "root"
})
export class ConversationService {

  lastConversations:  DTOConversation[];

  constructor(private conversationClient: ConversationClient) {

  }

  sendStartingConversationMessage(senderId: number, receiverId: number,nick:string, content: string, advertisementId: number, images: DTOImage[], subregionName: string = null, regionShortName: string = null, startDate: Moment = null): Promise<string> {
    return new Promise<string>((success, reject) => {

      const messageRequest = new StartConversationMessageSubmitRequestModel();
      messageRequest.content = content;
      messageRequest.receiverId = receiverId;
      messageRequest.senderId = senderId;
      messageRequest.senderNick=nick;
      messageRequest.advertisementId = advertisementId;
      messageRequest.images = images;

      if (subregionName != null || startDate != null) {
        messageRequest.additionalInformations = new ConversationAdditionalInformations();
        if (subregionName != null) {
          messageRequest.additionalInformations.subregionName = subregionName
        }

        if (regionShortName != null) {
          messageRequest.additionalInformations.regionShortName = regionShortName
        }

        if (startDate != null) {
          messageRequest.additionalInformations.advertisementData = startDate;
        }

      }

      this.conversationClient.sendStartingMessage(messageRequest).subscribe(result => {
        if (result.error && result.error != "") {
          reject(result.error)
        } else {
          success(result.conversationKey)
        }
      })
    })
  }

  sendMessageToExistingConversation(senderId: number, content: string, conversationId: number, images: DTOImage[]): Promise<string> {
    return new Promise<string>((success, reject) => {

      const messageRequest = new ConversationMessageSubmitRequestModel();
      messageRequest.content = content;
      messageRequest.senderId = senderId;
      messageRequest.conversationId = conversationId;
      messageRequest.images = images;

      this.conversationClient.sendConversationMessage(messageRequest).subscribe(result => {
        if (result.error && result.error != "") {
          reject(result.error)
        } else {
          success(result.conversationKey)
        }
      })
    })
  }

  deleteConversation(conversationId: number, arrayIndex: number = null): Promise<ConversationDeleteResponseModel> {
    return new Promise<ConversationDeleteResponseModel>((rs, rj) => {
      const deleteRequestModel = new ConversationDeleteRequestModel();
      deleteRequestModel.init({
        conversationId: conversationId
      });

      this.conversationClient.deleteConversation(deleteRequestModel).subscribe(result => {
        if (result.error && result.error != "") {
          rj(result.error)
        }
        if(this.lastConversations.length > 0 && !isNaN(arrayIndex)){
          this.lastConversations.splice(arrayIndex, 1);
        }
        rs(result)
      })
    })
  }

  getConversation(conversationId: number): Promise<DTOConversation> {
    return new Promise<DTOConversation>((resolve, reject) => {
      this.conversationClient.getConversation(conversationId).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(response.conversation);
        }
      });
    });
  }

  getConversations(perPage: number = 0, page: number = 0): Promise<UserConversationsResponseModel> {
    return new Promise<MessageSubmitResponseModel>((resolve, reject) => {

      this.conversationClient.getConversations(new UserConversationsRequestModel(), perPage, page).subscribe((result) => {
        if (result.error && result.error != "") {
          reject(result.error)
        } else {
          if(page==0){
            this.lastConversations = result.conversations;
          }
          resolve(result)
        }
      })
    })
  }

  getConversationsCount(): Promise<number> {
    return new Promise<number>((resolve, reject) => {

      this.conversationClient.getConversationsCount(new UserConversationsRequestModel()).subscribe((result) => {
        resolve(result);
      })
    })
  }

  getLastConversations(){
    return this.lastConversations;
  }

  getUnreadedMessageCount(): Promise<number> {
    return this.conversationClient.getUnreadedMessages().toPromise();
  }

  setReadedMessages(conversationId: number, messages: number[]): Promise<boolean> {
    if (!conversationId || messages == null || messages.length == 0) {
      return;
    }

    return this.conversationClient.setReadedMessages(messages, conversationId).toPromise();
  }

  getActiveConversationId(advertisementId: number) {
    return this.conversationClient.getActiveConversationId(advertisementId);
  }

  restoreConversationsHasMessages(): Promise<number> {
    return new Promise<number>((success, reject) => {
      this.conversationClient.restoreConvHasMessages().subscribe(result => {
        console.log(result);
      })
    })
  }
}
